import React from 'react';
import styled from 'styled-components';
import { Tab, TabProps } from 'react-tabs';
import { variant as ssVariant } from 'styled-system';
import { ColorProps } from '../../../theme/styledProps';
import { Text } from '../Text/Text';

type StepVariant = 'incomplete' | 'active' | 'complete';

export type Pseudo = '&::before';

interface ProgressProps {
  variant: StepVariant;
}

export const Progress = styled.span<ProgressProps>(
  {
    display: 'block',
    width: '100%',
    height: 4,
    borderRadius: 2,
  },

  ssVariant<ColorProps, StepVariant>({
    variants: {
      incomplete: {
        bg: 'neutral.200',
      },

      active: {
        bg: 'primary.500',
      },

      complete: {
        bg: 'primary.300',
      },
    },
  }),
);

const StepText = styled(Text)(({ theme }) => ({
  fontSize: theme.fontSizes.small,
  marginTop: 8,
}));

interface StepProps extends TabProps {
  variant?: StepVariant;
}

export const StyledStep = styled(Tab)<StepProps>(({ theme, disabled }) => ({
  flex: 1,
  listStyle: 'none',
  cursor: disabled ? 'initial' : 'pointer',

  '&[data-focus-visible-added]:not(.disabled):focus': {
    outline: 'none',
    boxShadow: `0px 0px 0px 2px ${theme.colors.primary['300']}, inset 0px 0px 0px 1px ${theme.colors.primary['500']}`,
    zIndex: 1,
  },
}));

interface StepFC extends React.FC<StepProps> {
  tabsRole: 'Tab';
}

export const Step: StepFC = ({ children, variant = 'incomplete', ...rest }) => {
  return (
    <StyledStep {...(rest as any)}>
      <Progress variant={variant} />

      <StepText>{children}</StepText>
    </StyledStep>
  );
};

Step.tabsRole = 'Tab';
